import { create } from "zustand";

type SessionPrefsState = {
  distanceUnit: "km" | "mile" | null;
  referenceCurrency: string;
  setDistanceUnit: (unit: "km" | "mile" | null) => void;
  setReferenceCurrency: (currency: string) => void;
};

export const useSessionPrefsStore = create<SessionPrefsState>((set) => ({
  distanceUnit: null,
  referenceCurrency: "USD",
  setDistanceUnit: (distanceUnit) => set({ distanceUnit }),
  setReferenceCurrency: (referenceCurrency) => set({ referenceCurrency }),
}));
